import React from 'react'
import AlertsConsumer from './AlertsConsumer'
import routes from '../config/routes'
import { HeroIcons } from '../lib/utils/heroIcons'
import { useTranslation } from 'next-i18next'
import { NavigationItem, NavigationPages } from '../types/Navigation'
import { useRouter } from 'next/router'
import Navbar from './Navbar'
import isRouteActive from '../lib/utils/isRouteActive'
import CompleteProfileBanner from './CompleteProfileBanner'
import { Toaster } from 'react-hot-toast'
import PromoPopup from './discount/PromoPopup'

type LayoutProps = {
  children: React.ReactNode
  hideBanner?: boolean
}

export default function Layout({ children, hideBanner = false }: LayoutProps) {
  const { t } = useTranslation('common')
  const router = useRouter()

  const navigation: NavigationItem[] = [
    {
      id: NavigationPages.HOME,
      name: t('navbar.home'),
      href: routes.index,
      icon: HeroIcons.HomeIcon,
      isActive: isRouteActive(routes.index, router.asPath),
    },
    {
      id: NavigationPages.STORE,
      name: t('navbar.properties'),
      href: routes.properties,
      icon: HeroIcons.BuildingOffice2Icon,
      isActive: isRouteActive(routes.properties, router.asPath),
    },
    {
      id: NavigationPages.ACCOUNT,
      name: t('navbar.account'),
      href: routes.account,
      icon: HeroIcons.UserIcon,
      isActive: isRouteActive(routes.account, router.asPath),
    },
  ]

  return (
    <div className="relative flex min-h-screen flex-col bg-slate-100">
      <AlertsConsumer />
      <PromoPopup />
      <Toaster
        toastOptions={{
          success: {
            style: {
              border: '1px solid green',
            },
          },
          error: {
            style: {
              border: '1px solid red',
            },
          },
        }}
      />
      <header className="sticky top-0 z-40 w-full px-3 pt-3 lg:px-32 xl:px-64">
        <div className="w-full space-y-3">
          <Navbar navigation={navigation} />
          {hideBanner ? (
            <></>
          ) : (
            <>
              <CompleteProfileBanner />
            </>
          )}
        </div>
      </header>
      <main className="flex grow flex-col px-3 pb-3 pt-3 lg:px-32 xl:px-64">
        {children}
      </main>
    </div>
  )
}
